import { Component, Inject } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedModule } from "../../shared/shared.module";
import type {
  PrintCardPageSizePreset,
  PrintCardPdfFormatDialogData,
  PrintCardPdfFormatDialogResult,
} from "../print-cards.interface";

@Component({
  selector: "app-print-card-pdf-format-dialog",
  templateUrl: "./print-card-pdf-format-dialog.component.html",
  styleUrls: ["./print-card-pdf-format-dialog.component.scss"],
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule],
})
export class PrintCardPdfFormatDialogComponent {
  readonly pageSizePresetControl = new FormControl<string>("", {
    nonNullable: true,
  });

  constructor(
    private readonly dialogRef: MatDialogRef<
      PrintCardPdfFormatDialogComponent,
      PrintCardPdfFormatDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public readonly data: PrintCardPdfFormatDialogData,
  ) {
    const defaultPresetId =
      data.selectedPresetId?.trim() || data.presets[0]?.id || "";
    const presetExists = data.presets.some(
      (preset) => preset.id === defaultPresetId,
    );
    this.pageSizePresetControl.setValue(
      presetExists ? defaultPresetId : (data.presets[0]?.id ?? ""),
      { emitEvent: false },
    );
  }

  get presets(): PrintCardPageSizePreset[] {
    return this.data.presets;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close({
      pageSizePresetId: this.pageSizePresetControl.value,
    });
  }
}
